<template>
    <div class="activity-indicator-grid">
        <div class="activity-indicator-grid activity-indicator-grid1" />
        <div class="activity-indicator-grid activity-indicator-grid2" />
        <div class="activity-indicator-grid activity-indicator-grid3" />
        <div class="activity-indicator-grid activity-indicator-grid4" />
        <div class="activity-indicator-grid activity-indicator-grid5" />
        <div class="activity-indicator-grid activity-indicator-grid6" />
        <div class="activity-indicator-grid activity-indicator-grid7" />
        <div class="activity-indicator-grid activity-indicator-grid8" />
        <div class="activity-indicator-grid activity-indicator-grid9" />
    </div>
</template>